<script setup lang="ts">
import AxureLogo from "ls/components/icons/AxureLogo.vue";
import { toHome } from "ls/router/builders";
import CenterLayout from "./Center.vue";

defineProps<{
  copyright?: boolean;
}>();
</script>

<template>
  <CenterLayout :copyright="copyright">
    <div class="min-w-0 flex-1 sm:max-w-96">
      <div class="rounded-sm bg-white p-6 shadow-xs">
        <div class="mb-4 flex justify-center">
          <RouterLink :to="toHome()">
            <AxureLogo dark class="h-6 w-20" />
            <span class="sr-only">Home</span>
          </RouterLink>
        </div>
        <slot />
      </div>
      <div v-if="$slots.secondary">
        <slot name="secondary" />
      </div>
    </div>
  </CenterLayout>
</template>
